import React, { PropsWithChildren } from "react";

import {
	StyledGridItem,
	StyledRow,
	StyledSpan,
	Style,
} from "../../../../../../common";

import Label from "./components/Label";

const Field: React.FC<Field.Props> = ({
	area,
	label,
	styledRow = {},
	styledSpan = {},
	children,
	font = { line: "14px" },
}) => (
	<StyledGridItem area={area} gap="8px">
		<StyledRow gap="8px" alignItems="start" {...styledRow}>
			<Label>{label}</Label>
			<StyledSpan
				font={font}
				text={{ ls: "0em", ws: "pre-wrap" }}
				colors="rgb(100, 112, 121)"
				{...styledSpan}
			>
				{children}
			</StyledSpan>
		</StyledRow>
	</StyledGridItem>
);

declare namespace Field {
	interface Props extends PropsWithChildren {
		area: string;

		label: string;

		styledRow?: Style.Row;
		styledSpan?: Style.TextType;
		font?: Style.FontTypographyType;
	}
}

export default Field;
